module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "padding-bottom": "20px"
    }
  }, [_c('b', [_vm._v("Профиль")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fas fa-times",
    staticStyle: {
      "font-size": "20px",
      "padding-right": "3px",
      "float": "right"
    }
  })])], 1), _vm._v(" "), (_vm.activeUser == null) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_vm._v("\n    Страница недоступна. Войдите в приложение\n  ")]) : _c('div', [_c('div', {
    staticClass: "user-avatar",
    style: ({
      'background-image': 'url(' + _vm.serverData.imagesGetURL(_vm.activeUser.body.avatar) + ')'
    })
  }, [_vm._v(" ")]), _vm._v(" "), _c('Form', {
    ref: "userData",
    staticClass: "passwordChanging",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "model": _vm.userData,
      "rules": _vm.userDataRules
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "15px",
      "padding-bottom": "5px"
    }
  }, [_vm._v("Имя")]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "userName"
    }
  }, [_c('Input', {
    staticClass: "input-left-icon",
    attrs: {
      "type": "text",
      "placeholder": "Имя",
      "icon": "android-contact",
      "size": "large"
    },
    on: {
      "on-blur": _vm.userNameOnBlur
    },
    model: {
      value: (_vm.activeUserName),
      callback: function($$v) {
        _vm.activeUserName = $$v
      },
      expression: "activeUserName"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "15px",
      "padding-bottom": "5px",
      "padding-top": "10px"
    }
  }, [_vm._v("Смена пароля")]), _vm._v(" "), _c('Form-item', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "prop": "currentPassword"
    }
  }, [_c('Input', {
    staticClass: "input-left-icon password",
    attrs: {
      "type": "password",
      "placeholder": "Текущий пароль",
      "icon": "locked",
      "size": "large"
    },
    model: {
      value: (_vm.userData.currentPassword),
      callback: function($$v) {
        _vm.userData.currentPassword = $$v
      },
      expression: "userData.currentPassword"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "prop": "newPassword"
    }
  }, [_c('Input', {
    staticClass: "input-left-icon",
    attrs: {
      "type": "password",
      "placeholder": "Новый пароль",
      "icon": "locked",
      "size": "large"
    },
    model: {
      value: (_vm.userData.newPassword),
      callback: function($$v) {
        _vm.userData.newPassword = $$v
      },
      expression: "userData.newPassword"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    staticStyle: {
      "margin-bottom": "25px"
    },
    attrs: {
      "prop": "newPasswordTwice"
    }
  }, [_c('Input', {
    staticClass: "input-left-icon",
    attrs: {
      "type": "password",
      "placeholder": "Новый пароль еще раз",
      "icon": "locked",
      "size": "large"
    },
    model: {
      value: (_vm.userData.newPasswordTwice),
      callback: function($$v) {
        _vm.userData.newPasswordTwice = $$v
      },
      expression: "userData.newPasswordTwice"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_c('Button', {
    staticClass: "login-form-button no-circle",
    attrs: {
      "type": "primary",
      "size": "large",
      "long": ""
    },
    on: {
      "click": function($event) {
        _vm.submitOnClick()
      }
    }
  }, [_vm._v("Сменить пароль")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47825b30","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile.vue
// module id = 356
// module chunks = 0